import { userConstants } from './../constants/user.constants';

const initialState = {};

export function UserSearchIns(state = initialState, action) {
  
  switch (action.type) {
    case userConstants.USERSEARCHINS_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.USERSEARCHINS_SUCCESS:
      const {res} = action
      return {
        res,
        isLoading : false
      };
    case userConstants.USERSEARCHINS_FAILURE:
      return {
        isLoading : false
      };
    case userConstants.USERSEARCHINS_CLEAR:
      return { ...state, res: null };
    default:
      return state
  }
}